import { Box, Typography } from '@mui/material'
import { ChatSearchRetrieveResponse } from '@fireflyhealth/api'
import ChatSearchResultSingle from './ChatSearchResultSingle'
import { Loader } from '~/shared/ui'
interface ChatSearchResultsProps {
  searchQuery: string
  searchResults: ChatSearchRetrieveResponse | null
  isLoading: boolean
  error?: Error | null
  handleResultClick: (id: number) => void
}

export const ChatSearchResultsV2 = (props: ChatSearchResultsProps) => {
  const { searchQuery, searchResults, isLoading, error, handleResultClick } = props

  // Show error state if search failed
  if (error) {
    return (
      <Box sx={{ p: 4 }}>
        <Typography sx={{ color: 'error.main', textAlign: 'center', fontWeight: 'bold' }}>
          Search failed
        </Typography>
        <Typography sx={{ color: 'text.secondary', textAlign: 'center' }}>
          Unable to search messages. Please try again.
        </Typography>
      </Box>
    )
  }

  // Show loading state while search is in progress
  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Loader />
      </Box>
    )
  }

  // No search results yet (search not triggered)
  if (!searchResults) return null

  // Show "no results" message if search was performed but no results found
  if (searchResults.results.length === 0) {
    return (
      <Typography sx={{ color: 'text.secondary', textAlign: 'center', m: 4 }}>
        No results found for &quot;{searchQuery}&quot;
      </Typography>
    )
  }

  return (
    <div>
      <Box sx={theme => ({ p: 2, borderBottom: `0.1rem solid ${theme.palette.divider}` })}>
        <Typography component="span" sx={{ fontWeight: 'bold' }}>
          {searchResults.total} {searchResults.total === 1 ? 'result ' : 'results '}
        </Typography>
        <Typography component="span">for &quot;{searchQuery}&quot;</Typography>
      </Box>
      {searchResults.results.map(result => (
        <ChatSearchResultSingle
          key={result.id}
          id={result.id}
          searchQuery={searchQuery}
          result={result}
          handleResultClick={handleResultClick}
        />
      ))}
    </div>
  )
}
